import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/logo27.png";
import "../navbar/navbar.css"
import { dadosLogin } from "../../zustand/zuztand";
import React, { useState, useEffect } from 'react';

function Navbar(props) {

    const navigate = useNavigate();
    const { usuario, changeIfLogado, nivel_user } = dadosLogin();  //user é o usuario que logou

    function Logout() {
        changeIfLogado("notLogad");
        navigate('/login');

    }

    const abrirToDoList = () => {
        window.open("http://casaludicafranquia.com.br/to-do-list", "_blank");
    };

    const [tasks, setTasks] = useState([]);
    const [input, setInput] = useState('');

    // Carregar tarefas do localStorage ao montar o componente
    useEffect(() => {
        const storedTasks = localStorage.getItem('tasks');
        if (storedTasks) {
            setTasks(JSON.parse(storedTasks));
        }
    }, []);

    // Atualizar localStorage sempre que as tarefas mudarem
    useEffect(() => {
        localStorage.setItem('tasks', JSON.stringify(tasks));
    }, [tasks]);

    const addTask = () => {
        const trimmedInput = input.trim();
        if (trimmedInput === '') return;
        const newTask = {
            id: Date.now(),
            text: trimmedInput,
            completed: false,
        };
        setTasks([...tasks, newTask]);
        setInput('');
    };

    const toggleTask = (id) => {
        setTasks(tasks.map(task =>
            task.id === id ? { ...task, completed: !task.completed } : task
        ));
    };

    const deleteTask = (id) => {
        setTasks(tasks.filter(task => task.id !== id));
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            addTask();
        }
    };

    return <>

        <div className="d-flex ">
            <nav className="navbar fixed-top navbar-expand-sm navbar-dark bg-white  mt-3 tam-nav">
                <div className="container-fluid">
                    <span className="nav-item">
                        <Link to="/dashboard-franquias"><img src={logo} className="logo-franquead me-4" /></Link>
                    </span>

                    <div className="collapse navbar-collapse " id="navbarSupportedContent">
                        <Link to="/menu-franquias" className={props.tela === "franquias" ? "btn-white me-3 nav-item-btn" : "btn-blue me-3 nav-item-btn"} aria-current="page">Franquias</Link>
                        <Link to="/menu-fornecedores" className={props.tela === "fornecedores" ? "btn-white me-3 nav-item-btn" : "btn-blue me-3 nav-item-btn"} aria-current="page">Fornecedores</Link>
                        <Link to="/menu-colaboradores" className={props.tela === "colaboradores" ? "btn-white me-3 nav-item-btn" : "btn-blue me-3 nav-item-btn"} aria-current="page">Colaboradores</Link>
                        <Link to="/menu-aniversariantes" className={props.tela === "aniversarios" ? "btn-white me-3 nav-item-btn" : "btn-blue me-3 nav-item-btn"} aria-current="page"><i className="fas fa-home"></i>Aniversariantes</Link>
                        <Link to="/menu-calendario" className={props.tela === "calendario" ? "btn-white me-3 nav-item-btn" : "btn-blue me-3 nav-item-btn"} aria-current="page">Calendário</Link>

                        <div className=" me-2 ">
                            <div className="btn-group menu-aux-nav">
                                <button className="btn text-white btn-sm dropdown-toggle fs-3 " type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-list me-2"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end444">
                                    <li> <button data-bs-toggle="modal" data-bs-target="#ModalToDoList" className="btn btn-to-do-list "><li className="ul-menu">Lista Tarefas</li></button></li>
                                    <li><a className="dropdown-item ul-menu" href="#">Relatórios</a></li>
                                    {
                                        usuario === "ariscoz@gmail.com" ?
                                            <Link to="/manutencao" className="text-decoration-none"><li className="dropdown-item ul-menu">Manutenção</li></Link> : null
                                    }
                                    <li> <Link to="#" className="text-decoration-none"><li className="dropdown-item ul-menu">Outros</li></Link></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><a onClick={Logout} className="dropdown-item ul-menu" href="#">Sair</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>

        {/* --------------------------------------------------Modal Inicio---------------------------------------------------------*/}
        <div className="modal fade" id="ModalToDoList" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Controle de Tarefas</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">

                        <div className="container my-2 app h-50">
                            <div className="row mb-3">
                                <div className="col-12 inp-task mb-2">
                                    <input
                                        type="text"
                                        className="form-control "
                                        placeholder="Digite uma nova tarefa"
                                        value={input}
                                        onChange={(e) => setInput(e.target.value)}
                                        onKeyPress={handleKeyPress}
                                    />
                                </div>
                                <div className="col">
                                    <button className="btn btn-primary w-100  btn-t-mobile" onClick={addTask}>
                                        Adicionar
                                    </button>
                                </div>
                            </div>
                            <ul className="list-group task-list">
                                {tasks.map(task => (
                                    <li key={task.id} className="list-group-item d-flex justify-content-between align-items-center">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={task.completed}
                                                onChange={() => toggleTask(task.id)}
                                                id={`task-${task.id}`}
                                            />
                                            <label className={`form-check-label ${task.completed ? 'text-decoration-line-through text-muted' : ''}`} htmlFor={`task-${task.id}`}>
                                                {task.text}
                                            </label>
                                        </div>
                                        <button className="btn btn-danger btn-sm " onClick={() => deleteTask(task.id)}>
                                            Excluir
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        {/* --------------------------------------------------Modal im---------------------------------------------------------*/}

    </>
}

export default Navbar;